import script from "./saveCode.vue?vue&type=script&setup=true&lang=js"
export * from "./saveCode.vue?vue&type=script&setup=true&lang=js"

import "./saveCode.vue?vue&type=style&index=0&id=e70bd39e&lang=scss&scoped=true"

import exportComponent from "D:\\zwy\\sdt\\云服务器租赁\\node_modules\\_vue-loader@17.0.1@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e70bd39e"]])

export default __exports__